// hooks
import { Fragment, useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, TextField, Button } from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";

// components
import BackButton from "components/shared/BackButton";
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import DatePickerCM from "components/shared/DatePicker";

// helper
import Toast from "helper/toast";
import { convertNum } from "helper/convert-num";

// styled component
import {
  StyledStack,
  StyledTitle,
  StyledDateBox,
  ButtonContainer,
} from "./EditUser.style";

//react date handler
import { DateObject } from "react-multi-date-picker";

// Request methods
import { getUserByIdRequest, updateUserByIdRequest } from "api/requests/users";

// form validate
import { userSchema } from "validations";

export default function EditUser() {
  const { user_id } = useParams();

  const navigate = useNavigate();

  const { request, loading, setLoading } = useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userSchema),
  });

  // user date state
  const [userDate, setUserDate] = useState("");

  // user date handler
  const onUserDateHandler = (value) =>
    setUserDate(
      value
        .format("YYYY-MM-DD")
        .split("-")
        .map((item) => convertNum(item))
        .join("-")
    );

  // update user
  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        updateUserByIdRequest({
          ...data,
          id: user_id,
          birth_date: userDate,
        }),
    });

    if (res) {
      Toast({ type: "success", title: "ویرایش کاربر" });
      reset({
        full_name: "",
        phone_number: "",
        email: "",
        address: "",
        birth_date: "",
      });
      navigate("/users");
    }
    setLoading(false);
  };

  // get user data by id
  const getUserByIdData = useCallback(async () => {
    const userRes = await request({
      url: () => getUserByIdRequest({ id: user_id }),
    });
    if (userRes) {
      let data = userRes.data;

      reset({
        full_name: data.full_name,
        phone_number: data.phone_number,
        email: data.email,
      });
      data.address &&
        reset({
          full_name: data.full_name,
          phone_number: data.phone_number,
          email: data.email,
          address: data.address,
        });
      if (data.birth_date.jdate) {
        setUserDate(data.birth_date.jdate.split(" ")[0]);
      }
    } else {
      Toast({ type: "err", title: "دریافت اطلاعات کاربر" });
    }
    setLoading(false);
  }, [setLoading]);

  useEffect(() => getUserByIdData(), [getUserByIdData]);

  return (
    <DrawerCM title="ویرایش کاربر">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/users" />
            </Grid>
            <StyledStack>
              <Grid>
                <StyledTitle>ویرایش کاربر</StyledTitle>
                <Grid container>
                  <Grid item md={4} xs={12} p={1.5}>
                    <TextField
                      id="full_name"
                      label="نام"
                      fullWidth
                      {...register("full_name")}
                      error={Boolean(errors.full_name)}
                      helperText={errors.full_name?.message}
                      // InputProps={{
                      //   readOnly: true,
                      // }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12} p={1.5}>
                    <TextField
                      id="phone_number"
                      {...register("phone_number")}
                      label="شماره تماس"
                      fullWidth
                      error={Boolean(errors.phone_number)}
                      helperText={errors.phone_number?.message}
                      // InputProps={{
                      //   readOnly: true,
                      // }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12} p={1.5}>
                    <TextField
                      id="email"
                      {...register("email")}
                      label="ایمیل"
                      fullWidth
                      error={Boolean(errors.email)}
                      helperText={errors.email?.message}
                      // InputProps={{
                      //   readOnly: true,
                      // }}
                    />
                  </Grid>
                  <Grid item md={8} xs={12} p={1.5}>
                    <TextField
                      label="آدرس"
                      variant="outlined"
                      fullWidth
                      id="address"
                      {...register("address")}
                      error={Boolean(errors.address)}
                      helperText={errors.address?.message}
                    />
                  </Grid>

                  <Grid item md={4} xs={12} p={1.5}>
                    <StyledDateBox>
                      <DatePickerCM
                        value={userDate}
                        onChange={onUserDateHandler}
                        render={(value, openCalendar) => {
                          return (
                            <TextField
                              label="تاریخ تولد"
                              variant="outlined"
                              fullWidth
                              id="birth_date"
                              {...register("birth_date")}
                              error={Boolean(errors.birth_date)}
                              helperText={errors.birth_date?.message}
                              value={value}
                              onClick={openCalendar}
                            />
                          );
                        }}
                      />
                    </StyledDateBox>
                  </Grid>
                </Grid>
              </Grid>

              <ButtonContainer>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ثبت
                </Button>
              </ButtonContainer>
            </StyledStack>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
